import React, { useEffect } from 'react';
import { useUpdateCurrentUserProfile } from './use-update-current-user-profile.hook';
import { useGetCurrentUserProfile } from './use-get-current-user-profile.hook';
import { intendUseOptions } from '../constants/intend-use-options';

export const defaultIntendUse = [];

export const useSignupIntendUse = () => {
  const { userProfile } = useGetCurrentUserProfile();
  const { updateUserProfile } = useUpdateCurrentUserProfile();
  const [intendUse, setIntendUse] = React.useState(defaultIntendUse);
  
  useEffect(() => {
    if (userProfile !== undefined && userProfile.intendUse) {
      // userProfile is already mapped — intendUse may be a comma-separated string
      const value = userProfile.intendUse;
      setIntendUse(
        Array.isArray(value)
          ? value
          : typeof value === 'string' && value
            ? value.split(',')
            : defaultIntendUse
      );
    }
  }, [userProfile]);

  const sendIntendUseRequest = async () => await updateUserProfile({'custom:intendUse': intendUse?.toString() || ''});

  return {
    intendUseOptions,
    intendUse,
    setIntendUse,
    sendIntendUseRequest
  };
};